export default {
  'menu.cms.site.website': 'Website settings',
  'menu.cms.site.sitemap': 'Sitemap',
  'menu.cms.site.robots': 'Robots',
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'Settings',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.cms.content': 'Content Assets',
  'menu.cms.content.all': 'All Content',
  'menu.cms.content.review': 'Review List',
  'menu.cms.content.categories': 'Category Management',
  'menu.cms.content.tags': 'Tag Management',
  'menu.cms.content.categories.master': 'Content Master',
  'menu.cms.content.categories.product': 'Product Content',
  'menu.cms.content.categories.solution': 'Solutions',
  'menu.cms.content.categories.case': 'Customer Cases',
  'menu.cms.content.categories.article': 'Articles and Insights',
  'menu.cms.content.categories.faq': 'FAQ and Terms',
  'menu.cms.content.categories.channel': 'Channel Versions',
  'menu.cms.content.categories.archive': 'Content Archive',
  'menu.cms.content.material': 'Media Library',
  'menu.cms.ai.topic': 'AI Topic',
  'menu.account': 'Account',
  'menu.cms.site.publication': 'Publication Records',
  'menu.cms.site.list': 'Site List',
  'menu.cms.site.categories': 'Categories',
  'menu.cms.site.analytics': 'Website Analytics',
  'menu.cms.settings.forms': 'Form Management',
  'menu.cms.settings.submissions': 'Submission Records',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
